import EventBriefings from "./EventBriefings";

export default EventBriefings;
